import {GameObject} from "./index";
import {GRAMMAR, STATE} from "../../Type";
import {Action, Block, Variable} from "../index";

export class Sprite extends GameObject {
  get type() {
    return "Sprite";
  }

  get category() {
    return "GameObject";
  }

  getDefaultChildren() {
    if (this.grammar === GRAMMAR.OBJECTIVE) {
      if (
        this.parent instanceof Action &&
        this.parent.data === "set" &&
        this.parent.parent instanceof Variable
      ) {
        return [new Block({state: STATE.INSTANCE, parent: this})];
      }
    } else {
      return super.getDefaultChildren();
    }
  }

  static getPrototypeBlock(sprite) {
    return new Sprite({
      data: sprite.name,
      uuid: sprite.uuid,
      state: STATE.PROTOTYPE,
    });
  }

  getAnimationIds() {
    const context = this.getParentContext();
    if (!context) return [];
    const gameObjectInfo = context.getGameObjectInfoWithName(this.data);
    if (!gameObjectInfo) return [];
    const animationIds = gameObjectInfo.animationIds || [];
    return animationIds;
  }
}
